module.exports = __webpack_public_path__ + "img/pic5.82d6c52d.jpg";